import { useUploader } from '@/hooks/useUploader';
import { useDrafts } from '@/hooks/useDrafts';
import ProductForm from '@/components/ProductForm';
import AIAssistantPanel from '@/components/AIAssistantPanel';

export default function UploadNew() {
  const { formData, updateField, errors, loading, validate, submit, reset } = useUploader();
  const { autoSave } = useDrafts();

  const handleSubmit = async () => {
    const id = await submit();
    if (id) {
      reset();
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-foreground">Upload New Product</h2>
          <p className="text-muted-foreground">Add a new product to your catalog</p>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <ProductForm
            data={formData}
            errors={errors}
            onChange={updateField}
            onSubmit={handleSubmit}
            loading={loading}
            mode="create"
          />
        </div>
        <div>
          <AIAssistantPanel
            productName={formData.name}
            category={formData.category}
            cost={formData.cost}
            onAcceptDescription={(desc) => updateField('description', desc)}
            onAcceptSpecs={(specs) => updateField('specs', specs)}
            onAcceptPrice={(price) => updateField('price', price)}
          />
        </div>
      </div>
    </div>
  );
}
